export const isDevel = () => process.env.NODE_ENV === 'development';
export const getBasePath = () => isDevel() ? "/" : "/map/";

export const getTs = () => Date.now()/1000;

export const getSecsLeft = (endTime) => {
	return Math.round(endTime - (new Date()).getTime()/1000);
};

export const gruntBossName = (incidentType, giovanni) => {
	switch(incidentType) {
		case 41:
			return 'Cliff';
		case 42:
			return 'Arlo';
		case 43:
			return 'Sierra';
		case 44:
			if( giovanni === true )
				return 'Giovanni!';
			else if( giovanni === false )
				return 'Decoy';
			else
				return 'Giovanni?';
		default:
			return false;
	}
};

export const formatTime = (date, showAmPm=false) => {
	if( typeof date === 'number' )
		date = new Date(date*1000);

	let hour = date.getHours() % 12;
	if( hour === 0 )
		hour = 12;

	var str = hour + ":" + ('0' + date.getMinutes()).slice(-2);
	if( showAmPm )
		str += date.getHours() / 12 >= 1 ? 'pm' : 'am';
	return str;
};

export const createGeoJSONCircle = function(center, radiusInKm, points) {
	if(!points) points = 64;

	var coords = {
		latitude: center[1],
		longitude: center[0]
	};

	var km = radiusInKm;

	var ret = [];
	var distanceX = km/(111.320*Math.cos(coords.latitude*Math.PI/180));
	var distanceY = km/110.574;

	var theta, x, y;
	for(var i=0; i<points; i++) {
		theta = (i/points)*(2*Math.PI);
		x = distanceX*Math.cos(theta);
		y = distanceY*Math.sin(theta);

		ret.push([coords.longitude+x, coords.latitude+y]);
	}
	ret.push(ret[0]);

	return {
		"type": "geojson",
		"data": {
			"type": "FeatureCollection",
			"features": [{
				"type": "Feature",
				"geometry": {
					"type": "Polygon",
					"coordinates": [ret]
				}
			}]
		}
	};
};

export const getGymIcon = (gym, isAdmin=false) => {
	if( gym['is_stale'] === 2 || (gym['is_stale'] === 1 && !isAdmin) )
		return 'https://www.a2pogo.com/images/pokemon/shields/Unknown.png';

	let icon = "/images/pokemon/shields/Uncontested.png";
	let teamMap = ['Uncontested', 'Mystic', 'Valor', 'Instinct'];
	if( gym.team_id ) {
		if( gym.slots_available === 0 )
			icon = "/images/pokemon/shields/" + teamMap[gym.team_id] + ".png";
		else
			icon = "/images/pokemon/shields/" + teamMap[gym.team_id] + "_"  + (6-gym.slots_available) + ".png";
	}

	return 'https://www.a2pogo.com' + icon;
};

// const padNumber = (n, width) => {
// 	n = n + '';
// 	return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
// }

export const getPokemonIcon = (pokemon, form=null) => {
	// if( typeof(pokemon) === 'number' ) {
	// 	const pokemon_id = pokemon;
	// 	if( !form ) form = 0;
	// 	pokemon = {pokemon_id, form};
	// }

	// const extra = pokemon.form ? '_' + padNumber(pokemon.form,2) : "";

	return 'https://raw.githubusercontent.com/whitewillem/PogoAssets/main/uicons/pokemon/' +
		pokemon.pokemon_id +'.png';
}

export const getIv = (pokemon) => {
	return Math.round((pokemon.iv_a + pokemon.iv_d + pokemon.iv_s) / 45 * 100);
};

export const restructureObject = (data) => {
	if( !data )
		return null;

	const headers = data.shift();
	return data.map(row => {
			const obj = {};
			row.forEach( (elt,idx) => obj[headers[idx]] = elt );
			return obj;
		}
	)
};

export const raidLevelMap = [{level: 1, name: 'Easy'}, {level: 3, name: 'Hard'}, {level: 5, name: 'Legendary'}, {level: 6, name: 'Mega'}];